// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2n0Ju","header":"ReportDetails_header__1VAIg","title":"ReportDetails_title__1Ou8X","left":"ReportDetails_left__1n1Tm"};